//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Link } from 'react-router-dom'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../breadcrumbCommon.scss'

// @ADD Component types
interface IBreadcrumbCommonLayoutProps {
  routes: any[]
  texts?: string[]
}

const BreadcrumbCommonLayout: React.FC<IBreadcrumbCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  let startRouteIndex: any
  props.routes.filter((route: any, index: number) => {
    if (route.path === '/') startRouteIndex = index
  })
  props.routes[startRouteIndex]['breadcrumb'] = t('components.breadcrumb.start')
  const breadcrumbs = useBreadcrumbs(props.routes)

  return(
    <div className='breadcrumb-component'>
      <nav aria-label='breadcrumb'>
        <ol className='breadcrumb'>
          {breadcrumbs.map((bread: any, i: number) => {
            // console.log(bread)
            return (
              <li key={bread.match.url} className='breadcrumb-item'>
                <Link to={bread.match.url}>
                  {props.texts && props.texts[i - 1] && <span className='text-truncate'>{props.texts[i - 1]}</span>}

                  {(!props.texts || !props.texts[i - 1]) && <span className='text-truncate'>{bread.breadcrumb}</span>}
                </Link>
              </li>
            )
          })}
        </ol>
      </nav>
    </div>
  )
}

export default BreadcrumbCommonLayout
